import { createBrowserRouter } from "react-router-dom"
import { SignInScreen } from "../screens/SignInScreen"

export const publicRouter = createBrowserRouter([
  {
    path: "/*",
    element: <SignInScreen />,
  },
])
